module.exports = __webpack_public_path__ + "static/media/nucleate_black_neo_sans.e99340dc.svg";